// Type of gifts with prices
export const gifts = {
	ENVELOPE: 'envelope',
	ENVELOPE_PRIZE: 0,

	BOX: 'giftbox',
	BOX_PRIZE: 5,

	BALLOONS: 'balloons',
	BALLOONS_PRIZE: 10,

	CHOCO: 'chocolate',
	CHOCO_PRIZE: 15,

	FLOWERS: 'flowers',
	FLOWERS_PRIZE: 20,

	BEAR: 'bear',
	BEAR_PRIZE: 30,
};

// Pages IDS
export const pages = {
	MESSAGE: 'TheFormMessage',
	GIFT: 'TheFormGift',
	PAYMENT: 'TheFormPayment',
	CONFIRMATION: 'TheFormConfirmation',
};

// Main site URL
export const SITE_URL = process.env.NODE_ENV === 'production' ? 'https://pow-web.netlify.app/' : 'http://www.wallofgiving.dev.au';

// API endpoint URL
export const API_URL = `${SITE_URL}/api`;

// Facebook settings
export const FB_APP_ID = process.env.NODE_ENV === 'production' ? '579644429072361' : '910260439155754';
export const FB_SDK_VERSION = 'v2.12';

export const STRIPE_KEY = process.env.NODE_ENV === 'production' ? 'pk_live_PdcqOnj9I8TQs5iDaxDRMUOD' : 'pk_test_ZDrgLaovTYTy3Xak7WjZc3Ud';



// WEBPACK FOOTER //
// ./src/constants.js